<div class="row">
    <div class="col-md-12">
        <div class="row modal_header">
            <div class="col-9">
                <span class="ml-2">{{value.head}}</span>
            </div>
            <div class="col-3 text-right">
                <a style="cursor:pointer">
                    <i class="fa-solid fa-xmark" (click)="Close()" style="font-size: xx-large;"></i>
                </a>
            </div>
        </div>
        <div class="card card_content">
            <form [formGroup]="deviceform" *ngIf="value.title=='newdevice'">
                <div class="row">

                    <div class="col-sm-12 col-md-6 ">
                        <mat-form-field appearance="fill" hideRequiredMarker>
                            <mat-label>Model</mat-label>
                            <input matInput maxlength="25" formControlName="model" placeholder="Enter your Model Name"
                                class="col-10" autocomplete="off">
                        </mat-form-field>
                    </div>
                    <div class="col-sm-12 col-md-6 ">
                        <mat-form-field appearance="fill" hideRequiredMarker>
                            <mat-label>Serial</mat-label>
                            <input matInput maxlength="25" formControlName="serial" placeholder="Enter your SerialNo"
                                class="col-10" autocomplete="off">
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">

                    <div class="col-sm-12 col-md-6 mt-4">
                        <mat-form-field appearance="fill" hideRequiredMarker>
                            <mat-label>Mac</mat-label>
                            <input matInput maxlength="25" formControlName="mac" placeholder="Enter your MAC"
                                class="col-10" autocomplete="off">
                        </mat-form-field>
                    </div>
                    <div class="col-xl-6 mt-4">
                        <mat-form-field appearance="fill" hideRequiredMarker>
                            <mat-label>Role</mat-label>
                            <mat-select class="scrollbarcs" formControlName="role" [disabled]="true"
                                placeholder="Select Primary Product ">
                                <mat-select-filter [displayMember]="'value'"></mat-select-filter>
                                <mat-option *ngFor="let role of rolelist" [value]="role.key"
                                    style="overflow-y: scroll !important;">
                                    {{role.value}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>


                <div class="row mt-4">
                    <div class="col-xl-12 text-center">
                        <button class="btn btn-secondary mr-3" (click)="adddevice()">
                            Save
                        </button>
                        <button class="btn btn-primary" (click)="Close()">
                            Cancel
                        </button>
                    </div>
                </div>

            </form>
            <form [formGroup]="form"
                *ngIf="value.title=='excelimport'|| value.title=='legalexcelimport' || value.title=='legalexcelrevoke' ">
                <div class="col-md-12" *ngIf="this.value.head !== 'LTE SIM Import'">
                    <div>
                        <button type="button" class="btn btn-primary" (click)="downloadtemplate()">
                            <i class="fa fa-download"></i> Download Template
                        </button>
                    </div>
                </div>
                <div class="row d-flex align-items-center flex-wrap grid-margin mt-4">
                    <div class="col-sm-12 col-md-12 mb-2 d-flex justify-content-center"
                        *ngIf="value.title == 'legalexcelimport'">
                        <div class="col-9" *ngIf="!value?.hideAgent">
                            <mat-form-field appearance="fill" hideRequiredMarker>
                                <mat-label>Agent Email</mat-label>
                                <input matInput maxlength="25" formControlName="agent" placeholder="Enter Agent Email"
                                    class="col-10" autocomplete="off" readonly>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-xl-12 d-flex justify-content-center mb-3"
                        *ngIf="this.value.head === 'LTE SIM Import'">
                        <div class="col-xl-9">

                            <mat-form-field appearance="fill" hideRequiredMarker>
                                <mat-label>Service Provider</mat-label>
                                <mat-select class="scrollbarcs" formControlName="serviceProviderId"
                                    placeholder="Please Select serviceProvider">
                                    <mat-select-filter [displayMember]="'value'" [array]="serviceProviderList"
                                        (filteredReturn)="serviceProviderList = $event"></mat-select-filter>
                                    <mat-option *ngFor="let item of serviceProviderList" [value]="item.key"
                                        style="overflow-y: scroll !important;">
                                        {{item.value}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-xl-12 d-flex justify-content-center mb-3"
                        *ngIf="(this.value.head === 'LTE SIM Import' && form.get('serviceProviderId')?.value)">
                        <div>
                            <button type="button" class="btn btn-primary" (click)="downloadtemplate()">
                                <i class="fa fa-download"></i> Download Template
                            </button>
                        </div>
                    </div>
                    <div class="col-xl-12 d-flex justify-content-center">
                        <div class="col-9">
                            <div class="padd-right-file " style="display: flex;">
                                <mat-form-field appearance="fill" hideRequiredMarker (click)="selectFile()">
                                    <mat-label>Attachment</mat-label>
                                    <input matInput id="AttachmentFileName" placeholder="Select Attachment"
                                        formControlName="AttachmentFileName" autocomplete="off" specialIsAlphaNumeric
                                        class="col-10" autocomplete="off" readonly>
                                </mat-form-field>
                                <button type="button" (click)="selectFile()" *ngIf="!isFileSelected"
                                    class="badge bg-light-blue image-button">
                                    <img src="../../../../assets/Home-Connect/icons/upload-Icon.svg"
                                        style="width: 26px;" />
                                </button>
                                <button type="button" (click)="reset()" *ngIf="isFileSelected"
                                    class="badge bg-light-blue image-button">
                                    <img style="filter: invert(1);width: 26px;"
                                        src="../../../../assets/Home-Connect/icons/delete.svg" />
                                </button>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="d-flex justify-content-center button-style mt-3">
                    <button class="btn btn-secondary mb-3 ml-3" type="submit" (click)="upload()"
                        matButton>Submit</button>
                </div>
            </form>
        </div>
    </div>
</div>